import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import Separator from "@material-ui/icons/LinearScale";
import Bullet from "@material-ui/icons/DragIndicator";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import InfoArea from "components/InfoArea/InfoArea.jsx";

import servicesStyle from "assets/jss/material-kit-pro-react/views/aboutUsSections/servicesStyle.jsx";

function SectionServices(props) {
  const { classes } = props;
  return (
    <div className={classes.services}>
      <GridContainer>
        <GridItem
          md={8}
          sm={8}
          className={classNames(
            classes.mlAuto,
            classes.mrAuto,
            classes.textCenter
          )}
        >

          <Separator /><Separator /><Separator />

          <h2 className={classes.title}>What we offer</h2>
          <h5 className={classes.description}>
            Kinos’s partnership culture, our commitment to excellence and uncompromising integrity makes us an excellent choice for investors with a long-term vision.
          </h5>

          <h5 className={classes.description}>Our client´s interest first is the core of our asset management philosophy.
We also custom tailor your investment strategies to clients’ specific needs.
</h5>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem md={4} sm={4}>
          <InfoArea
            title="FIRST CLASS."
            description={
              <span>
                <p>
                  We have a reputation for first class client service, which can be delivered through a number of different models, from a partner-led service by recognised leaders in the industry, to a more commoditised approach using outsourcing and the latest IT solutions.

                </p>

              </span>
            }
            icon={Bullet}
            iconColor="rose"
          />
        </GridItem>
        <GridItem md={4} sm={4}>
          <InfoArea
            title="MANAGEMENT OF ALL AREAS."
            description={
              <span>
                <p>
                  In addition to the typical secured real estate financing transactional work, we are increasingly involved advising on loan on loan financings, debt structuring, restructuring and on special situations, where we involve other experts from the Network.
                </p>

              </span>
            }
            icon={Bullet}
            iconColor="rose"
          />
        </GridItem>
        <GridItem md={4} sm={4}>
          <InfoArea
            title="DRIVING THOUGHT LEADERSHIP."
            description={
              <span>
                <p>
                  We are committed to and are passionate about real estate finance and, in addition to servicing our clients, we are involved with various industry bodies, proactively driving thought leadership and the development of the real estate finance markets.

                </p>
                
              </span>
            }
            icon={Bullet}
            iconColor="rose"
          />
        </GridItem>

      </GridContainer>
    </div>
  );
}


export default withStyles(servicesStyle)(SectionServices);
